var _path, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "alone icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.812 45.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16",
    d: "M116.278,261.017c6.37,1.262,12.972-1.059,16.483-5.805l4.34-5.865,3.551,11.175a4.057,4.057,0,0,0,3.958,2.606,3.856,3.856,0,0,0,4.109-3.53,3.018,3.018,0,0,0-.191-1.066l-5.67-15.433-.034-.008a2.479,2.479,0,0,0,2.3-2.164,2.411,2.411,0,0,0-1.821-2.535l-18.119-5.026h0a5.942,5.942,0,0,0-5.67-4.7l-.605-.053c-3.655-.315-6.928,1.938-7.358,5.077l-2.572,18.392C108.394,256.226,111.548,260.078,116.278,261.017ZM133.4,240.91l-.28-.065a5.2,5.2,0,0,0-.637.676l-7.039,9.079V238.936Z",
    transform: "translate(-108.907 -218.068)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 4",
    cx: 7.167,
    cy: 6.759,
    rx: 7.167,
    ry: 6.759,
    transform: "translate(13.041 0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlone);
export default __webpack_public_path__ + "static/media/alone.e4a40f22.svg";
export { ForwardRef as ReactComponent };